import { useState, createContext } from "react";
import { useDispatch } from "react-redux";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";
import {
  getReceptionInfoReceptionService,
  editReceptionInfoReceptionService,
  changeReceptionInfoActiveReceptionService,
} from "../../../services/receptionServices";
import { validateFile } from "../../../utils";
import { uploadUserService } from "../../../services/userServices";

export const infoReceptionContext = createContext({
  info: {},
  setInfo: () => {},
  handleGetInfo: () => {},
  handleEditInfo: () => {},
  handleChangeInfoActive: () => {},
  handleUploadFile: () => {},
});

const InfoReceptionContext = ({ children }) => {
  const dispatch = useDispatch();

  const [info, setInfo] = useState({});

  // Get Info
  const handleGetInfo = async () => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getReceptionInfoReceptionService();
      if (status === 200) {
        setInfo(data.result || {});
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Edit Info
  const handleEditInfo = async (userData) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await editReceptionInfoReceptionService(
        userData
      );
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        handleGetInfo();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Change Info Active
  const handleChangeInfoActive = async () => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } =
        await changeReceptionInfoActiveReceptionService();
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        handleGetInfo();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Upload File
  const handleUploadFile = async (file, destination, callback) => {
    const fileErrorMessage = validateFile(file);
    if (fileErrorMessage) return toastErrorMessage(fileErrorMessage);

    const objData = { file };
    const params = { destination };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await uploadUserService(objData, params);
      if (status === 200) {
        callback && callback(data.result);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <infoReceptionContext.Provider
      value={{
        info,
        setInfo,
        handleGetInfo,
        handleEditInfo,
        handleChangeInfoActive,
        handleUploadFile,
      }}
    >
      {children}
    </infoReceptionContext.Provider>
  );
};

export default InfoReceptionContext;
